export default "__VITE_ASSET__Cg0UKdjn__"